import interview from './../images/interview.png';

const Interview = () => {
  return (
    <div>
    <p className="standard-paragraph">
    
    <div class="container">
      <div class="image-container">
        <img src={interview} alt="Interview" width={300}/>
      </div>
      <div class="text-container">
        <h2>Interview</h2>
        <p class="text-text">  
          Unlock unparalleled expertise for your AWS projects with our talent recruitment services. We specialize in sourcing top-tier AWS 
          engineering professionals, ensuring a skilled team capable of navigating complex cloud environments. Complementing our 
          recruitment services, our software development offerings encompass end-to-end support, guaranteeing a seamless integration of 
          AWS engineering talents into your projects for optimal performance and innovation.
        </p>
      </div>
    </div>
    </p>
    </div>
    )
};

export default Interview;
